import { render, staticRenderFns } from "./aboutSvg.vue?vue&type=template&id=df3930de&"
import script from "./aboutSvg.vue?vue&type=script&lang=js&"
export * from "./aboutSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports